import { seatLayoutFor } from './seat-layouts';
import type { SeatCandidate } from './seat-identity';

/** Facility coordinates and a performance's stage configuration are separate evidence. */
export function layoutContextKey(seat: Pick<SeatCandidate, 'venueId' | 'spaceId'>): string {
  return `${seat.venueId}:${seat.spaceId}`;
}

export const officialFacilityFacts = [{
  venueId: 'sejong-center', spaceId: 's-theater', checkedAt: '2026-10-01',
  url: 'https://www.sejongpac.or.kr/portal/main/contents.do?menuNo=200371',
  statement: 'S씨어터 공식 시설 안내는 1층 196석, 2층 132석, 총 328석(휠체어석 4석 포함)이에요.',
}] as const;

export function officialLayoutAssessment(seat: Pick<SeatCandidate, 'venueId' | 'spaceId' | 'layoutVersionId' | 'instanceLabel'>, now = new Date()) {
  const layout = seatLayoutFor(seat.venueId, seat.spaceId);
  const facility = officialFacilityFacts.find((fact) => fact.venueId === seat.venueId && fact.spaceId === seat.spaceId);
  const isUnconfirmed = seat.layoutVersionId.includes('unconfirmed');
  const changed = Boolean(layout && !isUnconfirmed && seat.layoutVersionId !== layout.layoutVersionId);
  const sourceAgeDays = layout ? Math.max(0, Math.floor((now.getTime() - Date.parse(layout.source.checkedAt)) / 86_400_000)) : null;
  return { layout, facility, changed, sourceAgeDays,
    sourceRecheckDue: sourceAgeDays !== null && sourceAgeDays >= 30,
    instanceConfirmed: false as const,
    statement: changed ? '저장한 배치와 이 홀의 시설 배치가 달라요. 회차의 공식 좌석도를 다시 확인해 주세요.' : '시설 배치는 참고할 수 있지만, 선택한 회차의 무대 구성은 아직 확인하지 못했어요.',
  };
}

export function layoutCorrectionText(seat: Pick<SeatCandidate, 'venueName' | 'spaceName' | 'venueId' | 'spaceId' | 'layoutVersionId' | 'instanceLabel'>): string {
  const { layout } = officialLayoutAssessment(seat);
  return ['앉아봄 배치 정보 정정 요청 초안', `장소: ${seat.venueName} / ${seat.spaceName}`, `회차: ${seat.instanceLabel ?? '모름'}`, `앉아봄 배치: ${seat.layoutVersionId}`, `좌표 출처 확인일: ${layout?.source.checkedAt ?? '모름'}`, `공식 원문: ${layout?.source.url ?? '모름'}`, '', '잘못된 내용과 확인 가능한 공식 회차 안내 주소를 적어 주세요:'].join('\n');
}
